import React, { useState, useEffect, useMemo, useRef } from "react";
import { useNavigate, useLocation } from "react-router";
import "../shuttle_bus_booking.css";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "@progress/kendo-react-indicators";
import BackIcon from "../../../assets/communication/Back.svg";

import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import { checkPermission, getUserPermission } from "../../../config/permission_helper";
import { Stepper } from "@progress/kendo-react-layout";
import { CustomStep } from "../../../components/common/custom_steps";
import { SHUTTLE_BUS_BOOKING_CONFIGURE_SUSPENSION_LIST, SHUTTLE_BUS_BOOKING_CONFIGURE_SUSPENSION_UPDATE, SHUTTLE_BUS_BOOKING_SET_MAXIMUM_DETAILS, SHUTTLE_BUS_BOOKING_SET_MAXIMUM_LIST, SHUTTLE_BUS_BOOKING_SET_MAXIMUM_UPDATE } from "../../../routes";
import { ShowDialog } from "../../../components/reusableItems/dialog";
import { fetchConfigureSuspensionAudit, fetchConfigureSuspensionDetail, updateConfigureSuspensionStatus } from "../../../store/shuttle_bus_booking/configure_suspension";
import EditIcon from "../../../assets/common/EditIcon.svg";

export const ShuttleBusBookingConfigureSuspensionDetail = () => {
  const navigate = useNavigate();
  let { search } = useLocation();
  const dispatch = useDispatch();
  const query = new URLSearchParams(search);
  const id = query.get("id");

  const [showStatus, setShowStatus] = useState(false);
  const [tempStatus, setTempStatus] = useState("");

  const { detail_data, detail_loading, audit_data, audit_loading } = useSelector(
    (state) => state.shuttleBusConfigureSuspension
  );

  const userPermissions = getUserPermission();

  const viewPermssion = checkPermission(
    userPermissions,
    "bus_booking.access_suspension_config"
  );

  const updatePermssion = checkPermission(
    userPermissions,
    "bus_booking.update_suspension_config"
  );

  const getData = async () => {
    dispatch(fetchConfigureSuspensionDetail(id));
    dispatch(fetchConfigureSuspensionAudit(id));

  };


  useEffect(() => {
    getData();
  }, [id]);

  const updateStatus = () => {
    setShowStatus(false);

    let params = { is_enabled: tempStatus == 'Enable', id: id }

    dispatch(updateConfigureSuspensionStatus({ data: params, id: id })).then((res) => {
      getData();

    });
  };

  const clickUpdateStatus = () => {
    setShowStatus(true);
    setTempStatus(detail_data.is_enabled ? "Enable" : "Disable");
  };



  const getSortIcon = () => {
    return (<svg width="10" height="14" viewBox="0 0 10 14">
      <path d="M0 6 L5 1 L10 6 Z" fill="#999" />
      <path d="M0 8 L5 13 L10 8 Z" fill="#999" />
    </svg>);
  };
  return (
    <>
      {viewPermssion ? (
        <div className="inventory_container">

          {showStatus && (
            <ShowDialog
              cancelbtn={() => setShowStatus(false)}
              title={"Update Status"}
              dropdownContent={"Set status"}
              dropdown={true}
              cancelContent={"Cancel"}
              confrimContent={"Update"}
              confrinbtn={updateStatus}
              dropdownData={["Enable", "Disable"]}
              dropdownOnChange={(e) => setTempStatus(e)}
              dropdownValue={tempStatus}
            />
          )}

          {
            detail_loading && (
              <Loader
                type="converging-spinner"
                style={{
                  width: "100%",
                  height: "calc(100% - 75px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#ffffff4d",
                  position: "absolute",
                  zIndex: "999",
                }}
              />
            )
          }
          <div className="shuttle_bus_booking_detail_main_box">
            <div className="shuttle_bus_booking_detail_child_box">
              <div className="shuttle_bus_booking_detail_left_box">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div
                    className="shuttle_bus_booking_detail_back"
                    onClick={() => navigate(SHUTTLE_BUS_BOOKING_CONFIGURE_SUSPENSION_LIST)}
                  >
                    <span class="k-icon k-font-icon k-i-arrow-chevron-left" />
                    Back
                  </div>

                  {
                    updatePermssion && <div
                      className="shuttle_bus_booking_detail_edit"
                      onClick={() => navigate(`${SHUTTLE_BUS_BOOKING_CONFIGURE_SUSPENSION_UPDATE}?id=${id}`)}
                    >
                      <img src={EditIcon} />
                      Edit
                    </div>
                  }

                </div>
                <div className={"shuttle_bus_booking_detail_child_box_main_detail_box"}>
                  <div className="shuttle_bus_booking_create_item_main_box_detail">
                    <div className="shuttle_bus_booking_create_item_main_box_title">
                      Configure Rules for Suspension Matrix
                    </div>
                    <div style={{ marginTop: "10px", border: "1px solid #eee", borderRadius: "5px" }}>

                      <table className="styled-table">
                        <thead>
                          <tr>
                            <th>
                              Type {getSortIcon()}
                            </th>
                            <th>
                              Number of Absence/Cancelled {getSortIcon()}
                            </th>
                            <th>
                              Limit {getSortIcon()}
                            </th>

                          </tr>
                        </thead>
                        <tbody>
                          <tr key={'configure'} style={{ height: "100px" }}>
                            <td>{detail_data.sk}</td>
                            <td>{detail_data.threshold}</td>
                            <td>{`${detail_data.value} ${detail_data.period_range == 'weeks' ? 'Weeks' : 'Months'}`}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>



                  </div>
                </div>


              </div>
              <div className="shuttle_bus_booking_detail_right_box">
                <div className="shuttle_bus_booking_detail_right_status_box">
                  <div className="shuttle_bus_booking_detail_right_box_status_title">
                    Status
                  </div>
                  <div className={detail_data.is_enabled ? "shuttle_bus_booking_detail_right_box_status_subdetail" : "shuttle_bus_booking_detail_right_box_status_subdetail_reject"}>
                    {detail_data
                      ? detail_data.is_enabled ? "Enable" : "Disable"
                      : "-"}
                  </div>
                </div>
                <div className="shuttle_bus_booking_detail_right_box_action_main_box">
                  <div className="shuttle_bus_booking_detail_right_box_action_title">
                    Actions
                  </div>

                  <div
                    className="shuttle_bus_booking_detail_right_box_action_edit"
                    onClick={() => clickUpdateStatus()}
                  >
                    Update Status &#x2192;
                  </div>

                </div>

                <div className="shuttle_bus_booking_detail_right_box_action_main_box">
                  <div className="shuttle_bus_booking_detail_right_box_action_title">
                    Activity Trail
                  </div>
                  <div className={audit_data.length <= 1 && "audit_bar_hide"}>
                    {audit_loading ? (
                      <Loader
                        type="converging-spinner"
                        style={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          background: "#ffffff4d",
                        }}
                      />
                    ) : (
                      <Stepper
                        orientation={"vertical"}
                        items={audit_data}
                        item={CustomStep}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>


          </div>

        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}

    </>
  );
};
